(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

// import * as THREE from 'three';

var ThreeView = function ThreeView(options, rendererOptions) {
  var _this = this;

  //
  rendererOptions = Object.assign({
    antialias: true,
    autoClearColor: false,
    alpha: true
  }, rendererOptions || {});

  // create the porperties in this object
  Object.assign(this, {

    width: window.innerWidth,

    height: window.innerHeight,

    aspect: window.innerWidth / window.innerHeight,

    // renderer: new THREE.WebGLRenderer(),
    renderer: options && options.renderer ? options.renderer : new THREE.WebGLRenderer(rendererOptions),

    setSize: function setSize(w, h) {

      _this.width = w || window.innerWidth;

      _this.height = h || window.innerHeight;

      _this.aspect = _this.width / _this.height;

      if (_this.renderer) {

        _this.renderer.setSize(_this.width, _this.height);
      }
    },

    onResize: function onResize(event) {
      //...
    }

  }, options || {});

  // append the renderer to our container
  if (this.container) {

    if (typeof this.container === 'string') {
      this.container = document.getElementById(this.container);
    }

    this.container.appendChild(this.renderer.domElement);
  }

  (function () {
    var throttle = function throttle(type, name, obj) {
      obj = obj || window;
      var running = false;
      var func = function func() {
        if (running) {
          return;
        }
        running = true;
        requestAnimationFrame(function () {
          obj.dispatchEvent(new CustomEvent(name));
          running = false;
        });
      };
      obj.addEventListener(type, func);
    };

    /* init - you can init any event */
    throttle("resize", "optimizedResize");
  })();

  // handle event
  window.addEventListener("optimizedResize", function () {
    console.log("Resource conscious resize callback!");
    _this.setSize();
    _this.onResize(event, _this.width, _this.height);
  });

  // // window events
  // var resizeTimeout = null
  // var resizeTimeStep = 50
  // window.addEventListener('resize', event => {

  //   if ( !resizeTimeout ) {
  //     resizeTimeout = setTimeout( () => {
  //       resizeTimeout = null;
  //       this.setSize()
  //       this.onResize( event, this.width, this.height );
  //     }, resizeTimeStep);
  //   }
  // })


  // setup
  this.setSize();
};

module.exports = ThreeView;

},{}],2:[function(require,module,exports){
"use strict";

var _sketch = require("./sketch.js");

var _sketch2 = _interopRequireDefault(_sketch);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// var hideLoadingDiv = () => {
//   document.getElementById('loading_message').style.display = 'none'
// }

window.onload = function () {

  (0, _sketch2.default)();
};

},{"./sketch.js":3}],3:[function(require,module,exports){
'use strict';

var _ThreeView = require('./ThreeView.js');

var _ThreeView2 = _interopRequireDefault(_ThreeView);

var _touchEvents = require('./touchEvents.js');

var _touchEvents2 = _interopRequireDefault(_touchEvents);

var _eases = require('../lsr/eases.js');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var gltfLoader = new THREE.GLTFLoader();
// import * as THREE from 'three';
// window.THREE = THREE
// var glslify = require('glslify')

// import isMobile from 'ismobilejs'

// const MOBILE = isMobile.any;


// import * as THREE from 'three';
// import '../libs/THREE/OrbitControls.js'
// import '../libs/THREE/GLTFLoader.js'

var elapsedTime = 0;

var sin = Math.sin;
var cos = Math.cos;
var pow = Math.pow;
var PI = Math.PI;
var TWO_PI = Math.PI * 2;
var HALF_PI = Math.PI * 0.5;
var random = Math.random;
var randf = THREE.Math.randFloat;
var randi = THREE.Math.randInt;
var lerp = THREE.Math.lerp;
var mapLinear = THREE.Math.mapLinear;
var clamp = THREE.Math.clamp;

var loadingManager = new THREE.LoadingManager();
var textureLoader = new THREE.TextureLoader(loadingManager);
var jsonLoader = new THREE.FileLoader(loadingManager);
jsonLoader.setResponseType('json');

// OUR SKETCH
var Sketch = function Sketch() {

  var clock = new THREE.Clock();

  // scene
  var scene = new THREE.Scene();
  // scene.fog = new THREE.Fog( 0x000000, 1, 1000 );

  // camera
  var camera = new THREE.PerspectiveCamera(90, window.innerWidth / window.innerHeight, //aspect
  0.01, 100);
  camera.position.set(0.015108707467579918, 0.5128852970744067, 0.20482374981744583);

  // view - convenience object to setup the renderer
  var view = new _ThreeView2.default({
    container: 'container'
  });

  var renderer = view.renderer;
  renderer.setClearColor(new THREE.Color(0xffffff), 0);
  renderer.autoClear = false;

  // // TODO: Reuse existing WebGLRenderer, GLTFLoaders, and so on
  // var renderer = new THREE.WebGLRenderer( { antialias: true } );
  // renderer.setPixelRatio( window.devicePixelRatio );
  // renderer.setSize( window.innerWidth, window.innerHeight );
  // renderer.gammaOutput = true;
  // renderer.physicallyCorrectLights = true;


  // orbit controls
  var controls = new THREE.OrbitControls(camera, renderer.domElement);
  controls.target.y = 0.2;
  controls.update();

  // lighting... I don't think we'll end up using it though
  var light = new THREE.PointLight(0xE5F2FF, 1);
  light.position.set(0, 10, -10);
  scene.add(light);

  var hemi_light = new THREE.HemisphereLight(0xDAE6F2, 0x44484C, 0.6);
  scene.add(hemi_light);

  var stripCount = 2;
  var stripData = [];
  for (var i = 0; i < stripCount; i++) {
    [22, 24, 25, 137, 145, 153].forEach(function (val) {

      stripData.push(val);
    });
  }
  var dataTex = new THREE.DataTexture(new Uint8Array(stripData), stripCount * 2, 1, THREE.RGBFormat /*, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy */);

  dataTex.needsUpdate = true;

  var loader = new THREE.GLTFLoader();

  var mixer = null;

  var skel = null;
  var originalPositions = [];

  var meshes = [];

  var gradient = textureLoader.load("./static/snoothGradient_wbw.png", function (result) {
    console.log(result);

    result.repeat.set(4, 4);
  });

  var mat = new THREE.MeshStandardMaterial({
    emissive: new THREE.Color(),
    skinning: true,
    emissiveMap: gradient
  });
  var count = 23,
      radius = 20;
  for (var i = 0; i < count; i++) {

    loader.load(
    // resource URL
    'static/animTestTwo.glb',
    // called when the resource is loaded
    function (gltf) {

      var model = gltf.scene;
      scene.add(model);
      model.rotation.set(-1, 0, 0);

      model.traverse(function (child) {

        // need to add the armature(bones) to the scene so they'll update
        if (child.name === "Armature") {

          // child.children[1].material = mat

          child.children[1].material = new THREE.MeshStandardMaterial({
            emissive: new THREE.Color(0x000000),
            skinning: true,
            metalness: 1,
            metalnessMap: dataTex,
            roughness: 0.2,
            emissiveMap: dataTex
            // map: dataTex
            // metalnessMap: gradient
          });
          // child.rotation.set(1,0,0)
          meshes.push(child);
          child.children[0].position.x = sin(mapLinear(meshes.length, 0, count, 0, TWO_PI)) * radius;
          child.children[0].position.z = cos(mapLinear(meshes.length, 0, count, 0, TWO_PI)) * radius;

          child.children[0].rotation.y = mapLinear(meshes.length, 0, count, 0, TWO_PI);
          child.children[0].rotation.z = mapLinear(meshes.length, 0, count, 0, TWO_PI);
        }
      });
    }, undefined,
    // called when loading has errors
    function (error) {
      // console.log( 'An error happened' );
    });
  }

  // update function called once per rAf loop
  var update = function update() {
    var delta = clock.getDelta();
    elapsedTime = clock.getElapsedTime();

    // elapsedTime += cos(elapsedTime * 0.1)

    meshes.forEach(function (m, i) {

      m.rotation.y = elapsedTime * 0.1;

      var t = sin(elapsedTime + mapLinear(i, 0, count, TWO_PI, -TWO_PI)) * 0.5 + 0.5;
      var u = (0, _eases.ElasticIn)(1 - pow(1 - t, 3));

      m.children[1].material.emissiveIntensity = u - 0.1;

      // m.children[1].material.emissive.setHSL(i*0.1,0.3,0.5)

      var scl = (u * 0.5 + 0.5) / m.children[1].skeleton.bones.length;

      m.children[1].skeleton.bones.forEach(function (b, j) {

        // t += cos(elapsedTime * 0.1 + i * 0.1 ) * 0.25

        b.rotation.x = u * j * scl;
        b.rotation.z = u * u * j * scl;

        b.scale.y = (1 - u) * 0.5 + 1;

        // b.rotation.z = sin(elapsedTime * 0.6 + j * 0.1 )
      });

      m.children[1].skeleton.bones[0].rotation.z = sin(elapsedTime * 0.2 + i * 0.05) * 2;
    });
  };

  // draw function called once per rAf loop
  var draw = function draw() {

    // console.log( "draw" );
    renderer.render(scene, camera, null, true);

    // post.render(renderer, scene, camera, null, false )
  };

  // events
  view.onResize = function (e, w, h) {
    console.log(e.type, w, h);
    camera.aspect = view.aspect;
    camera.updateProjectionMatrix();
  };

  var onScroll = function onScroll(e) {
    console.log(e.type);
  };

  var trackedTouches = null;
  var touches = new _touchEvents2.default({

    element: view.container,

    onTouchStart: function onTouchStart(e) {
      // console.log( e.type, e );
      trackedTouches = e.touches;
    },

    onTouchMove: function onTouchMove(e) {

      if (!trackedTouches) return;

      onScroll({
        type: e.type,
        deltaX: trackedTouches[0].pageX - e.touches[0].pageX,
        deltaY: trackedTouches[0].pageY - e.touches[0].pageY
      });

      trackedTouches = e.touches;
    },

    onTouchEnd: function onTouchEnd(e) {
      // console.log( e.type, e );
    }

  });

  window.addEventListener('wheel', onScroll);

  // keyboard inputs
  window.addEventListener('keypress', function (e) {

    switch (e.key) {

      case 's':
        break;

      case 'c':
        console.log(camera.position.x, camera.position.y, camera.position.z);
        return;

      default:
        return;
    }
  });

  // rAf loop
  function animate() {
    requestAnimationFrame(animate);
    update();
    draw();
  }

  animate();
};

module.exports = Sketch;

},{"../lsr/eases.js":5,"./ThreeView.js":1,"./touchEvents.js":4}],4:[function(require,module,exports){
'use strict';

// touchEvents.js

var ongoingTouches = [];

module.exports = function (options) {
  var _this = this;

  var touchStartCallback = function touchStartCallback(e) {
    _this.onTouchStart(e);
  };
  var touchMoveCallback = function touchMoveCallback(e) {
    _this.onTouchMove(e);
  };
  var touchEndCallback = function touchEndCallback(e) {
    _this.onTouchEnd(e);
  };

  Object.assign(this, {

    element: null,

    onToushStart: function onToushStart(e) {},

    onTouchMove: function onTouchMove(e) {},

    onTouchEnd: function onTouchEnd(e) {},

    addListeners: function addListeners(el) {

      if (_this.element !== el) {
        _this.removeListeners();
      }

      _this.element = el;

      el.addEventListener('touchstart', touchStartCallback, false);
      el.addEventListener('touchend', touchEndCallback, false);
      el.addEventListener('touchmove', touchMoveCallback, false);
    },

    removeListeners: function removeListeners() {

      if (_this.element) {

        _this.element.removeEventListener('touchstart', touchStartCallback, false);
        _this.element.removeEventListener('touchend', touchEndCallback, false);
        _this.element.removeEventListener('touchmove', touchMoveCallback, false);
      }

      _this.element = null;
    }

  }, options || {});

  // setup
  if (this.element) {

    this.addListeners(this.element);
  }
};

},{}],5:[function(require,module,exports){
"use strict";

module.exports = {

  zero: function zero() {
    return 0;
  },

  one: function one() {
    return 1;
  },

  linear: function linear(k) {
    return k;
  },

  smooth: function smooth(x) {
    if (x <= 0) return 0;
    if (x >= 1) return 1;
    return x * x * (3 - 2 * x);
  },

  smoother: function smoother(x) {
    if (x <= 0) return 0;
    if (x >= 1) return 1;
    return x * x * x * (x * (x * 6 - 15) + 10);
  },

  QuadraticIn: function QuadraticIn(k) {
    return k * k;
  },

  QuadraticOut: function QuadraticOut(k) {
    return k * (2 - k);
  },

  QuadraticInOut: function QuadraticInOut(k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k;
    }

    return -0.5 * (--k * (k - 2) - 1);
  },

  CubicIn: function CubicIn(k) {
    return k * k * k;
  },

  CubicOut: function CubicOut(k) {
    return --k * k * k + 1;
  },

  CubicInOut: function CubicInOut(k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k * k;
    }
    return 0.5 * ((k -= 2) * k * k + 2);
  },

  QuarticIn: function QuarticIn(k) {
    return k * k * k * k;
  },

  QuarticOut: function QuarticOut(k) {
    return 1 - --k * k * k * k;
  },

  QuarticInOut: function QuarticInOut(k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k * k * k;
    }
    return -0.5 * ((k -= 2) * k * k * k - 2);
  },

  QuinticIn: function QuinticIn(k) {
    return k * k * k * k * k;
  },

  QuinticOut: function QuinticOut(k) {
    return --k * k * k * k * k + 1;
  },

  QuinticInOut: function QuinticInOut(k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k * k * k * k;
    }
    return 0.5 * ((k -= 2) * k * k * k * k + 2);
  },

  SinusoidalIn: function SinusoidalIn(k) {
    return 1 - Math.cos(k * Math.PI / 2);
  },

  SinusoidalOut: function SinusoidalOut(k) {
    return Math.sin(k * Math.PI / 2);
  },

  SinusoidalInOut: function SinusoidalInOut(k) {
    return 0.5 * (1 - Math.cos(Math.PI * k));
  },

  ExponentialIn: function ExponentialIn(k) {
    return k === 0 ? 0 : Math.pow(1024, k - 1);
  },

  ExponentialOut: function ExponentialOut(k) {
    return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
  },

  ExponentialInOut: function ExponentialInOut(k) {
    if (k === 0) {
      return 0;
    }
    if (k === 1) {
      return 1;
    }
    if ((k *= 2) < 1) {
      return 0.5 * Math.pow(1024, k - 1);
    }
    return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
  },

  CircularIn: function CircularIn(k) {
    return 1 - Math.sqrt(1 - k * k);
  },

  CircularOut: function CircularOut(k) {
    return Math.sqrt(1 - --k * k);
  },

  CircularInOut: function CircularInOut(k) {
    if ((k *= 2) < 1) {
      return -0.5 * (Math.sqrt(1 - k * k) - 1);
    }
    return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
  },

  ElasticIn: function ElasticIn(k) {
    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    return -Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);
  },

  ElasticOut: function ElasticOut(k) {
    if (k === 0) {
      return 0;
    }
    if (k === 1) {
      return 1;
    }
    return Math.pow(2, -10 * k) * Math.sin((k - 0.1) * 5 * Math.PI) + 1;
  },

  ElasticInOut: function ElasticInOut(k) {
    if (k === 0) {
      return 0;
    }
    if (k === 1) {
      return 1;
    }
    k *= 2;
    if (k < 1) {
      return -0.5 * Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);
    }
    return 0.5 * Math.pow(2, -10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI) + 1;
  },

  BackIn: function BackIn(k) {
    var s = 1.70158;
    return k * k * ((s + 1) * k - s);
  },

  BackOut: function BackOut(k) {
    var s = 1.70158;
    return --k * k * ((s + 1) * k + s) + 1;
  },

  BackInOut: function BackInOut(k) {
    var s = 1.70158 * 1.525;
    if ((k *= 2) < 1) {
      return 0.5 * (k * k * ((s + 1) * k - s));
    }
    return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
  },

  BounceIn: function BounceIn(k) {
    return 1 - this.BounceOut(1 - k);
  },

  BounceOut: function BounceOut(k) {
    if (k < 1 / 2.75) {
      return 7.5625 * k * k;
    } else if (k < 2 / 2.75) {
      return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
    } else if (k < 2.5 / 2.75) {
      return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
    } else {
      return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    }
  },

  BounceInOut: function BounceInOut(k) {
    if (k < 0.5) {
      return this.BounceIn(k * 2) * 0.5;
    }
    return this.BounceOut(k * 2 - 1) * 0.5 + 0.5;
  }
};

},{}]},{},[2]);
